// extracted by mini-css-extract-plugin
export default {"formLabel":"styles_formLabel__0tjIS","formLabelLabel":"styles_formLabelLabel__3Pgil","formLabelRequired":"styles_formLabelRequired__d3dLh"};